import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { campaignBudgetCreativeValidator, campaignLanguageCreativeValidator } from 'src/whiteLabel/mediaCorps/services/campaign/campaign-validators';

@Injectable()
export class ValidatorAdapter {

    constructor() {
    }

    public getCampaignValidator(): Array<ValidatorFn> {
        return [
            campaignBudgetCreativeValidator(),
            campaignLanguageCreativeValidator()
        ];
    }
}
